import script from "./cascade-login.vue?vue&type=script&lang=ts&setup=true"
export * from "./cascade-login.vue?vue&type=script&lang=ts&setup=true"

import "./cascade-login.vue?vue&type=style&index=0&id=7e666da2&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e666da2"]])

export default __exports__